import * as Yup from 'yup'

export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Formato inválidos')
    .min(3, 'E-mail deve possuir no mínimo 3 caracteres')
    .max(50, 'E-mail deve possuir no máximo 50 caracteres')
    .required('E-mail é obrigatório'),
})
